import { createBrowserRouter } from 'react-router-dom';
import MainLayout from 'layout/MainLayout/MainLayout';
import ROUTES from 'constants/routes';
import BugReportListPage from 'pages/BugReport/List';
import CompanyListPage from 'pages/Company/List';
import CompanyViewPage from 'pages/Company/View';
import UserListPage from 'pages/User/List';
import UserViewPage from 'pages/User/View';
import Login from 'pages/Login';
import CompetencyMapListPage from 'pages/CompetencyMap/list';
import LogsList from 'pages/Logs/List';

const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <Login />,
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: ROUTES.BUG_REPORTS,
        children: [
          {
            index: true,
            element: <BugReportListPage />,
          },
        ],
      },
      {
        path: ROUTES.COMPANIES,
        children: [
          {
            index: true,
            element: <CompanyListPage />,
          },
          {
            path: ':companyId',
            element: <CompanyViewPage />,
          },
        ],
      },
      {
        path: ROUTES.USERS,
        children: [
          {
            index: true,
            element: <UserListPage />,
          },
          {
            path: ':userId',
            element: <UserViewPage />,
          },
        ],
      },
      {
        path: ROUTES.COMPETENCY_MAPS,
        children: [
          {
            index: true,
            element: <CompetencyMapListPage />,
          },
        ],
      },
      {
        path: ROUTES.LOGS,
        children: [
          {
            index: true,
            element: <LogsList />,
          },
        ],
      },
    ],
  },
]);

export default router;
